"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GetExtendedCampaignOverviewAllOfSender {
    static getAttributeTypeMap() {
        return GetExtendedCampaignOverviewAllOfSender.attributeTypeMap;
    }
}
GetExtendedCampaignOverviewAllOfSender.discriminator = undefined;
GetExtendedCampaignOverviewAllOfSender.attributeTypeMap = [
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "email",
        "baseName": "email",
        "type": "string"
    },
    {
        "name": "id",
        "baseName": "id",
        "type": "string"
    }
];
exports.GetExtendedCampaignOverviewAllOfSender = GetExtendedCampaignOverviewAllOfSender;
//# sourceMappingURL=getExtendedCampaignOverviewAllOfSender.js.map